module.exports = __webpack_public_path__ + "img/nmea.8fc48a15.svg";